// src/components/Registry/Registry.jsx
import React from 'react';
import './css/Registry.css';

const Registry = () => {
  const cards = [
    {
      badge: "П° 29212",
      title: "Единый реестр отечественного ПО",
      content: "Безопасный контур — российская разработка, включённая в Единый реестр отечественного ПО (П° 29212), что делает её подходящей для импортозамещения иностранных аналогов.",
      buttonText: "Посмотреть"
    },
    {
      badge: "#1",
      title: "Первые в России",
      content: "Безопасный контур — первый в России продукт, применяющий технологии искусственного интеллекта для поиска и классификации персональных данных.",
      buttonText: "Посмотреть"
    }
  ];

  return (
    <section className="registry">
      <div className="registry-container">
        {/* Сетка карточек */}
        <div className="registry-grid">
          {cards.map((card, index) => (
            <div key={index} className="registry-card">
              {/* Бейдж только для первой карточки */}
    
                <div className="registry-badge">{card.badge}</div>
          
              
              <div className="registry-card-content">
                <h3 className="registry-card-title">{card.title}</h3>
                <p className="registry-card-text">{card.content}</p>
                
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Registry;